import { type PayStep } from "../PayDialog";
import PaymentOptionButton from "../ui/PaymentOptionButton";

export default function MainOptionsStep({
  setStep,
}: {
  setStep: (s: PayStep) => void;
}) {
  return (
    <div className="space-y-4 animate-slideIn">
      <PaymentOptionButton label="💎 FAVARA QR (BML Transfer)" color="bg-purple-600" onClick={() => setStep("transfer")} />
      <PaymentOptionButton label="💳 BML Payment Gateway" color="bg-indigo-600" onClick={() => setStep("bmlgateway")} />
      <PaymentOptionButton label="💎 Pay with Points" color="bg-blue-600" onClick={() => setStep("points")} />
      <PaymentOptionButton label="💳 Pay with Card" color="bg-indigo-600" onClick={() => setStep("card")} />
      <PaymentOptionButton label="📱 Mobile Payment" color="bg-green-600" onClick={() => setStep("mobile")} />
    </div>
  );
}